export default __webpack_public_path__ + "static/media/404-error-img.f8ce9fd4.png";